export default "__VITE_ASSET__D1s7fw9a__"